
import Vue from 'vue';
import _mapKeys from 'lodash/mapKeys';
import { TeamMember } from '@run-diffusion/shared';
import { mapState } from 'vuex';
import TableBulkActionsPopover from '@/components/base/TableBulkActionsPopover.vue';

export default Vue.extend({
	name: 'BulkModeRunnitBoardMembersManagement',
	props: {
		addedTeamMembers: { type: Array, default: () => [] },
	},
	data () {
		const DEFAULT_PAGINATION = {
			sortBy: ['email'],
			sortDesc: [false],
		};
		return {
			DEFAULT_PAGINATION,
			pagination: DEFAULT_PAGINATION,
			itemsPerPageOptions: [25, 100],
			selectedRows: [],
		};
	},
	computed: {
		...mapState([
			'user',
		]),
		headers () {
			return [
				{
					noDownload: true,
					text: 'Email',
					value: 'email',
					align: 'left',
					class: 'py-0 pl-0 pr-1',
					sortable: true,
				},
				{
					noDownload: true,
					text: '',
					align: 'right',
					class: 'py-0 pr-4',
					sortable: false,
				},
			];
		},
	},
	watch: {
		addedTeamMembers: {
			immediate: true,
			handler (newVal: TeamMember[], oldVal: TeamMember[]) {
				// Sync selectedRows with latest data
				if (newVal !== oldVal && this.selectedRows.length > 0) {
					const allMembersMap: Record<string, TeamMember> = _mapKeys(newVal, 'id');
					this.selectedRows = this.selectedRows.map((member: TeamMember) => allMembersMap[member.id] || member);
				}
			},
		},
	},
	methods: {
		clearSelectedRows () {
			this.$nextTick(() => {
				// Next tick seems to prevent issue with check boxes getting in a state where they're unselectable after a bulk update and clear selected items operation
				this.selectedRows = [];
			});
		},
		onRemoveItems(items: TeamMember[]) {
			this.$emit('remove-added-members', items);
		},
		onRemoveItemsInBulk() {
			this.onRemoveItems(this.selectedRows);
			this.clearSelectedRows();
		},
	},
	components: {
		TableBulkActionsPopover,
	},
});
